import { Component } from '@angular/core';
import { ObjectType } from '@vendasta/auxiliary-data-components';
import { CustomDataUpdatedPanelComponent } from './custom-data-updated-panel/custom-data-updated-panel.component';
import {
  GenericCustomDataUpdatedPanelComponent,
  GenericCustomDataUpdatedPanelTemplate,
} from './generic-custom-data-updated-panel.component';

@Component({
  imports: [CustomDataUpdatedPanelComponent],
  template: GenericCustomDataUpdatedPanelTemplate,
})
export class AccountCustomDataUpdatedPanelComponent extends GenericCustomDataUpdatedPanelComponent {
  objectType: ObjectType = 'business';
  panelTitle = 'AUTOMATIONS.EDITOR.TRIGGERS.CUSTOM_DATA_UPDATED.CUSTOM_DATA_UPDATED.ACCOUNT';
}
